import {
  b100,
  b200,
  b300,
  b600,
  b800,
  backgroundAccentBlue,
  backgroundAccentBlueSubtlest,
  backgroundAccentBlueSubtlestHovered,
  backgroundAccentGray,
  backgroundAccentGreen,
  backgroundAccentLime,
  backgroundAccentMagenta,
  backgroundAccentOrange,
  backgroundAccentPurple,
  backgroundAccentRed,
  backgroundAccentTeal,
  backgroundAccentYellow,
  backgroundDisabled,
  backgroundInput,
  backgroundInputHovered,
  borderDefaultColor,
  borderDisabled,
  borderFocused,
  chartGrayBoldestHovered,
  g100,
  g150,
  g300,
  g600,
  g800,
  ghostConnectorPreview,
  iconAccentBlue,
  iconAccentGray,
  iconAccentGreen,
  iconAccentLime,
  iconAccentMagenta,
  iconAccentOrange,
  iconAccentPurple,
  iconAccentRed,
  iconAccentTeal,
  iconAccentYellow,
  iconDefaultColor,
  iconDisabled,
  iconSubtle,
  l100,
  l200,
  l300,
  l600,
  l800,
  m100,
  m200,
  m300,
  m600,
  m800,
  matchActiveColor,
  matchColor,
  matchBorderColor,
  matchActiveBorderColor,
  n200,
  n400,
  n600,
  n800,
  neutralLight,
  none,
  o100,
  o300,
  o600,
  o800,
  orange,
  p100,
  p200,
  p300,
  p600,
  p800,
  r100,
  r300,
  r600,
  r800,
  red,
  sectionTextGrey,
  sectionTextWhite,
  shadowOverflow,
  t100,
  t300,
  t600,
  t800,
  teal,
  textAccentBlue,
  textAccentGreen,
  textAccentLime,
  textAccentMagenta,
  textAccentOrange,
  textAccentPurple,
  textAccentRed,
  textAccentTeal,
  textAccentYellow,
  textDefaultColor,
  textDisabled,
  textSubtle,
  textSubtlest,
  white,
  y100,
  y150,
  y300,
  y600,
  y800,
} from '../colors';

import {
  currentUserSelectionColor,
  multiSelectionColor,
  lockedSelectionColor,
  privateSelectionColor,
  equidistantSpacingGuideColor,
} from './selection';

// Note: the order elements appear in this map matters for presentation
// Just keeping this here now for dark mode compatibility, which we don't officially support
export const oldStickyColorMap = {
  orange,
  b200,
  p200,
  m200,
  y150,
  g150,
  teal,
  red,
};

export const textColorMap = {
  textDefaultColor,
  textAccentBlue,
  textAccentTeal,
  textAccentGreen,
  textAccentLime,
  textAccentYellow,
  textAccentOrange,
  textAccentRed,
  textAccentMagenta,
  textAccentPurple,
};

export const iconColorMap = {
  iconAccentGray,
  iconAccentBlue,
  iconAccentTeal,
  iconAccentGreen,
  iconAccentLime,
  iconAccentYellow,
  iconAccentOrange,
  iconAccentRed,
  iconAccentMagenta,
  iconAccentPurple,
};

export const backgroundColorMap = {
  neutralLight,
  backgroundAccentBlue,
  backgroundAccentTeal,
  backgroundAccentGreen,
  backgroundAccentLime,
  backgroundAccentYellow,
  backgroundAccentOrange,
  backgroundAccentRed,
  backgroundAccentMagenta,
  backgroundAccentPurple,
};

export const shadowColorMap = {
  shadowOverflowSpread: shadowOverflow,
  shadowOverflowPerimeter: shadowOverflow,
};

export const outlineColorMap = {
  n800,
  b800,
  t800,
  g800,
  l800,
  y800,
  o800,
  r800,
  m800,
  p800,
};

export const strongestColorMap = {
  n600,
  b600,
  t600,
  g600,
  l600,
  y600,
  o600,
  r600,
  m600,
  p600,
};

export const strongColorMap = {
  n400,
  b300,
  t300,
  g300,
  l300,
  y300,
  o300,
  r300,
  m300,
  p300,
};

export const mediumColorMap = {
  n200,
  b200,
  teal,
  g150,
  l200,
  y150,
  orange,
  red,
  m200,
  p200,
};

export const lightColorMap = {
  white,
  b100,
  t100,
  g100,
  l100,
  y100,
  o100,
  r100,
  m100,
  p100,
};

export const miscellaneousColorMap = {
  borderDefaultColor,
  borderDisabled,
  borderFocused,
  chartGrayBoldestHovered,
  sectionTextGrey,
  sectionTextWhite,
  textDisabled,
  textSubtle,
  textSubtlest,
  backgroundDisabled,
  backgroundInput,
  backgroundInputHovered,
  backgroundAccentGray,
  iconDefaultColor,
  iconSubtle,
  iconDisabled,
  backgroundAccentBlueSubtlest,
  backgroundAccentBlueSubtlestHovered,
  currentUserSelectionColor,
  multiSelectionColor,
  lockedSelectionColor,
  privateSelectionColor,
  matchColor,
  ghostConnectorPreview,
  matchActiveColor,
  matchBorderColor,
  matchActiveBorderColor,
  equidistantSpacingGuideColor,
};

export const elementColorMap = {
  none,
  ...textColorMap,
  ...outlineColorMap,
  ...strongestColorMap,
  ...strongColorMap,
  ...mediumColorMap,
  ...lightColorMap,
  ...iconColorMap,
  ...backgroundColorMap,
  ...shadowColorMap,
}; // Convert our palette configurations into maps for consumption downstream

export const mindMapColorMap = {
  b600,
  t600,
  g600,
  l600,
  y600,
  o600,
  r600,
  m600,
  p600,
};
